// src/components/registration/steps/functions/utilityStepFunctions.js

/**
 * Extracts and formats the company name from a user role string.
 *
 * @param {string} role - The user role string in the format "Part1-Company Name-Part3".
 * @returns {string|null} - The formatted company name with spaces replaced by underscores, or null if the format is invalid.
 */
export const extractCompanyName = (role) => {
  console.log("Extracting");
  if (typeof role !== "string") {
    console.error("Invalid input: role must be a string.");
    return null;
  }

  const parts = role.split("-");

  // Ensure the role string has at least three parts
  if (parts.length < 3) {
    console.error(
      'Invalid role format. Expected format: "Part1-Company Name-Part3".'
    );
    return null;
  }

  const companyNameRaw = parts[1].trim();

  if (!companyNameRaw) {
    console.error("Company name segment is empty.");
    return null;
  }

  // Replace spaces with underscores to format the company name
  const formattedCompanyName = companyNameRaw.replace(/ /g, "_");

  return formattedCompanyName;
};
